import { Base, createApp, importWhenVisible } from '@studiometa/js-toolkit';
import { isDev } from '#js/config.js';
import HomeHeader from './organisms/HomeHeader.js';
import { Figure } from '@studiometa/ui';
import Reveal from './atoms/Reveal.js';
import Slider from './molecules/Slider.js';
import Hours from './molecules/Hours.js';
import ButtonsSlider from './molecules/ButtonsSlider.js';

/**
 * App class.
 */
class App extends Base {
  /**
   * App config.
   * @type {import('@studiometa/js-toolkit').BaseConfig}
   */
  static config = {
    log: isDev(),
    name: 'App',
    components: {
      Figure,
      HomeHeader,
      Hours,
      HeroSlider: (app) =>
        importWhenVisible(() => import('./molecules/HeroSlider.js'), 'HeroSlider', app),
      Reveal,
      Slider,
      Map: (app) => importWhenVisible(() => import('./organisms/Map/index.js'), 'Map', app),
      ButtonsSlider,
    },
  };

  /**
   * Log a nice message when app is ready.
   * @returns {void}
   */
  mounted() {
    this.$log('mounted 🎉');
  }
}

export default createApp(App, document.body);
